import { Project } from "interfaces";

import * as flowConfig from "./config";

export interface ForecastingProject extends Project {
  flow: flowConfig.FLOW_TYPE;
  data_files: { [flowConfig.INPUT_DATA]: string };
  meta_data: {
    [flowConfig.TARGET_VAR_KEY]: string;
    [flowConfig.TIMESTAMP_VAR_KEY]: string;
    [flowConfig.GROUPING_VARS_KEY]?: string[];
  };
}

export const projectIsForecastingAnalysis = (
  project: Project
): project is ForecastingProject => project.flow === flowConfig.FLOW_NAME;
